import ContentfulPageImageTitleHero from '@entries/contentful-page-image-title-hero'
import ContentfulPageImageTitleLandingHero from '@entries/contentful-page-image-title-landing-hero'
import ContentfulPageImageTitleLandingHeroFosfo from '@entries/contentful-page-image-title-landing-hero-fosfo'
import ContentfulPageImageTitleLandingHeroGold from '@entries/contentful-page-image-title-landing-hero-gold'
import ContentfulPageImageTitleLandingHeroOps from '@entries/contentful-page-image-title-landing-hero-ops'
import ContentfulPageImageTitlePictoHero from '@entries/contentful-page-image-title-picto-hero'
import ContentfulPageImageTitleRefreshInformational from '@entries/contentful-page-image-title-refresh-informational'
import ContentfulPageImageTitleRefreshLanding from '@entries/contentful-page-image-title-refresh-landing'
import ContentfulPageImageTitleRefreshProduct from '@entries/contentful-page-image-title-refresh-product'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { ContentfulPageImageTitleTemplate } from '@typings/contentful-page-image-title-template'
import { graphql } from 'gatsby'
import React from 'react'

import ContentfulPageImageTitlePodcastHero from './contentful-page-image-title-podcast-hero'

const DefaultComponent: Utils.EntryFC<
  Queries.ContentfulPageImageTitleFragment
> = ({ content }) => {
  console.log(`Template Page Image Title not supported: ${content.template}`)
  return <div></div>
}

const ContentfulPageImageTitle: Utils.EntryFC<
  Queries.ContentfulPageImageTitleFragment
> = ({ content }) => (
  <Entry
    content={content}
    mappingKeyResolver={({ template }) => template || 'default'}
    mapping={{
      [ContentfulPageImageTitleTemplate.HERO]: ContentfulPageImageTitleHero,
      [ContentfulPageImageTitleTemplate.PICTO]:
        ContentfulPageImageTitlePictoHero,
      [ContentfulPageImageTitleTemplate.LANDING_HERO]:
        ContentfulPageImageTitleLandingHero,
      [ContentfulPageImageTitleTemplate.LANDING_HERO_GOLD]:
        ContentfulPageImageTitleLandingHeroGold,
      [ContentfulPageImageTitleTemplate.LANDING_HERO_FOSFO]:
        ContentfulPageImageTitleLandingHeroFosfo,
      [ContentfulPageImageTitleTemplate.LANDING_HERO_OPS]:
        ContentfulPageImageTitleLandingHeroOps,
      [ContentfulPageImageTitleTemplate.REFRESH_PRODUCT]:
        ContentfulPageImageTitleRefreshProduct,
      [ContentfulPageImageTitleTemplate.REFRESH_LANDING]:
        ContentfulPageImageTitleRefreshLanding,
      [ContentfulPageImageTitleTemplate.REFRESH_INFORMATIONAL]:
        ContentfulPageImageTitleRefreshInformational,
      [ContentfulPageImageTitleTemplate.PODCAST]:
        ContentfulPageImageTitlePodcastHero,
      default: DefaultComponent,
    }}
  />
)

export const query = graphql`
  fragment ContentfulPageImageTitle on Contentful3TUjMz7TxKWiQYygwIysig {
    ...ContentfulEntry
    ...ContentfulPageImageTitlePictoHero
    ...ContentfulPageImageTitleHero
    ...ContentfulPageImageTitleLandingHeroFosfo
    ...ContentfulPageImageTitleLandingHeroGold
    ...ContentfulPageImageTitleLandingHeroOps
    ...ContentfulPageImageTitleLandingHero
    ...ContentfulPageImageTitleRefreshProduct
    ...ContentfulPageImageTitleRefreshLanding
    ...ContentfulPageImageTitleRefreshInformational
    ...ContentfulPageImageTitlePodcast
    template
  }
`

export default withDisplayName(
  ContentfulPageImageTitle,
  'ContentfulPageImageTitle'
)
